<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Joni Scott had a scientific career as an organic chemist and biochemist in hospitals and industry. She also home-schooled her children and embarked on another career running a tutoring business. After writing her debut novel, <em>Whispers Through Time</em>, she contracted CRPS and lost the use of her dominant right arm and hand. In early 2020, she travelled to Italy for treatment but ended up in lockdown. This experience inspired her second novel, <em>The Last Hotel</em> which she wrote with her left hand. Though the physical act of writing is still a struggle, Joni is determined to continue. <em>Time Heal My Heart</em> is her third novel and can be read as a free-standing novel or sequel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?bee111f2